<template>
<div>
  <h2>Szablon</h2>
  <v-form ref="form">
    <v-text-field :rules="[v => (!!v && v.length > 3) || 'Nazwa powinna byc dłuższa']" v-model="model" label="Szablon OCR"></v-text-field>
    <v-btn color="green" @click="submit()">Ok</v-btn>
  </v-form>
</div>
</template>

<script>
export default {
  data() {
    return {
      schema: {},
      model: "",
    }
  },
  created() {
    this.$http.get(`document/template/schema/${this.$route.params.schemaId}`)
        .then(data => {
          this.model = data.data.template
        })
        .catch(() => null)
  },
  methods: {
    submit() {
      if (!this.$refs.form.validate()) {
        return
      }

      let postData = this.createPostData()
      this.$http.post(`document/template/schema/${this.$route.params.schemaId}`, postData).then(() => {
        this.$store.commit('setSnack', {
          message: "Dodano szablon",
          color: 'success'
        })
      }).catch(() => {
        this.$store.commit('setSnack', {
          message: "Problem z dodaniem szablonu",
          color: 'danger'
        })
      })
    },
    createPostData() {
      return {
        'template': this.model
      }
    },
  },
}
</script>
